import { BaseAPI } from 'apis/amazon';
import { AxiosResponse } from 'axios';
import { GetSimplecastPreviewResponse } from './upload.service';

export type { SimplecastPreviewProgramResponse } from './upload.service';

export type SimplecastRssValidationCode =
  | 'VALID'
  | 'INVALID_API_KEY'
  | 'NOT_FOUND'
  | 'NOT_PRIMARY'
  | 'NOT_ENABLED'
  | 'ERROR';

export type SimplecastRssValidationResponse = {
  valid: boolean;
  code: SimplecastRssValidationCode;
  message: string | null;
  rssFeedUrl?: string;
  programId?: string;
};

export type SimplecastRssValidationPayload = {
  apiKey: string;
  programId: string;
  rssFeedUrl: string;
};

export const SimplecastService = {
  getProgramIds: (
    apiKey: string,
  ): Promise<AxiosResponse<GetSimplecastPreviewResponse>> => {
    return BaseAPI.get(`/upload/simplecast/preview`, {
      params: { apikey: apiKey.trim() },
    });
  },
  validateRssFeed: (
    payload: SimplecastRssValidationPayload,
  ): Promise<AxiosResponse<SimplecastRssValidationResponse>> => {
    return BaseAPI.post('/upload/simplecast/rss/health', {
      apiKey: payload.apiKey.trim(),
      programId: payload.programId,
      rssFeedUrl: payload.rssFeedUrl.trim(),
    });
  },
};
